import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './auth.interceptor';

//lembrando que eles executam de cima para baixo
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS,
     useClass: AuthInterceptor, 
     multi: true },
];
